import VueI18n, { TranslateResult } from 'vue-i18n';
import FakeTranslationsService from './fake-translation.service';
// import { fakeT, FakeTClass } from './fake-t';
// import { i18n } from '@/main';
// import router from '@app/router/index.APP_TARGET';
import { i18n } from '@/main';
import store from '@app/store';
import router from '@app/router/index.APP_TARGET';
import BPCApiRouteHelper from '@core/helpers/bpc-api-route.helper';
import { bpcApi } from '@core/services/bpc-api.service';

const bpcRouterHelper = new BPCApiRouteHelper();

export class TranslationReportService {
  setMessages(messages) {
    store.commit('tReport/setMessages', messages);
  }

  $t(key: VueI18n.Path, values?: VueI18n.Values): TranslateResult {
    // Before executing this
    // 0. Create a file with all the translation comming from backend named potentially_not_used_translations
    const t = i18n.t(key, values) as string;
    const locale = i18n.locale;
    const currentRoute = router.currentRoute.path;

    // 1. Remove the key from the potentially_not_used_translations and add it to used_translations file
    store.commit('tReport/removeFromPotentiallyUnusedTranslations', { locale, key });

    // 2. Check if the string has a translated value
    if (i18n.te(key)) {
      // 2.a If it has a translation -> add it to used translations
      store.commit('tReport/setUsedTranslations', { locale, key, t, currentRoute });
    }
    // 2.b If it has no translated value -> add it to used_with_missing_translation file
    else {
      store.commit('tReport/setMissingTranslations', { locale, key, currentRoute });
    }

    return t;
  }

  getTranslationService() {
    return new FakeTranslationsService(this);
  }

  downloadAllMessages() {
    this.downloadObjectAsJson(store.getters['tReport/allMessages'], 'all-messages');
  }

  downloadMissingTranslations() {
    this.downloadObjectAsJson(store.getters['tReport/missingTranslations'], 'missing-translations');
  }

  downloadUsedTranslations() {
    this.downloadObjectAsJson(store.getters['tReport/usedTranslations'], 'used-translations');
  }

  downloadPotentiallyUnusedTranslations() {
    this.downloadObjectAsJson(
      store.getters['tReport/potentiallyUnusedTranslations'],
      'potentially-unused-translations',
    );
  }

  downloadObjectAsJson(exportObj: object, exportName: string) {
    const dataStr = `data:text/json;charset=utf-8,${encodeURIComponent(
      JSON.stringify(exportObj, null, 2),
    )}`;
    const downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute('href', dataStr);
    downloadAnchorNode.setAttribute('download', exportName + '.json');
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  }
}
